import { get } from 'lodash';

const config = (configKey, callback = null) => {
    const defaultOptions = {
        polling: {
            interval: 10000,
        },
        toast: {
            timeout: 4000,
        },
        debounce: {
            wait: 1000,
        },
        media: {
            ...ca.media,
        },
        branding: {
            ...ca.branding,
        },
        services: {
            ...ca.services,
        },
        editor: {
            ...ca.editor,
        },
        cascon: {
            ...ca.cascon,
        },
        forms: {
            ...ca.forms,
        },
    };

    return get(defaultOptions, configKey);
};

export default config;
